"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _imageSrc = require("../../lib/imageSrc");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _lodash = require("lodash");
var _FinproHeadTags = _interopRequireDefault(require("../../components/finpro/headtag/FinproHeadTags"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a Brokerage Director (BD) Profile
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering.fields.data BD detail
 *
 * @returns {React.ReactElement} BD profile
 */
function BrokerageDirectorProfile(props) {
  var _extractedFields$hero;
  if (!props.rendering.fields || !props.rendering.fields.data) {
    return null;
  }
  var extractedFields = (0, _lodash.get)(props, 'rendering.fields.data');
  var profilePhoto = (0, _imageSrc.finproProfileImageHref)(extractedFields.profileImage);
  var ProcessHeadtags = () => {
    if ((0, _lodash.isEmpty)(extractedFields.fullName)) {
      var metadata = {
        pagePath: props.params.pagePath
      };
      return /*#__PURE__*/_react.default.createElement(_FinproHeadTags.default, {
        pageType: 'default',
        metadata: metadata
      });
    } else {
      var _metadata = {
        name: extractedFields.fullName,
        pagePath: extractedFields.agentUrl,
        pageQuery: props.params.pageQuery,
        utagSiteName: props.pageprops.utagSiteName,
        addUtagLoginCookie: props.pageprops.addUtagLoginCookie
      };
      return /*#__PURE__*/_react.default.createElement(_FinproHeadTags.default, {
        pageType: 'brokerage',
        metadata: _metadata
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container"
  }, /*#__PURE__*/_react.default.createElement(ProcessHeadtags, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Jumbotron, {
    variant: "dark-secondary",
    backgroundImageUrl: (0, _imageSrc.finproProfileImageHref)((_extractedFields$hero = extractedFields.heroBanner) === null || _extractedFields$hero === void 0 ? void 0 : _extractedFields$hero.backgroundImage)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-media-object reverse"
  }, /*#__PURE__*/_react.default.createElement("picture", {
    className: "mm-img-circle--xl"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: profilePhoto,
    alt: "MassMutual financial professional."
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, "TBD: Profile data and content display, following raw data", /*#__PURE__*/_react.default.createElement("pre", null, JSON.stringify(extractedFields, null, 2))));
}
var _default = exports.default = BrokerageDirectorProfile;